<!-- 表口径列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('方案名称')">
              <a-input  :placeholder="$t('请输入升级方案名称')" v-model="queryParam.fotaTaskName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('新固件版本号')">
              <a-input  :placeholder="$t('请输入新固件版本号')" v-model="queryParam.softwareNewVersion"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
        >
        <span slot="action" slot-scope="text, record">
          <!--
          <a @click="handleEdit(record)">编辑</a>
          -->
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
            <a>{{ $t('删除') }}</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <software-modal ref="modalForm" @ok="modalFormOk"></software-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {isUndefined} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import softwareModal from './modules/softwareModal'
  export default {
    name: 'MeterCaliberList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      softwareModal
    },
    data () {
      return {
        description: 'software管理页面',
        url: {
          list: "/jeecg-charge/meter/meterFotaSoft/list",
          delete: "/jeecg-charge/meter/meterFotaSoft/delete",
          deleteBatch: "/jeecg-charge/meter/meterFotaSoft/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterFotaSoft/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterFotaSoft/importExcel",  
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('方案名称'),
            align:"center",
            dataIndex: 'fotaTaskName'
          },{
            title: this.$t('新固件型号'),
            align:"center",
            dataIndex: 'softwareNewName'
          },{
            title: this.$t('新固件版本号'),
            align:"center",
            dataIndex: 'softwareNewVersion'
          },{
            title: this.$t('旧固件型号'),
            align:"center",
            dataIndex: 'softwareOldName'
          },{
            title: this.$t('旧固件版本号'),
            align:"center",
            dataIndex: 'softwareOldVersion'
          },{
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
</style>